import { useState } from 'react';
import { Star } from '../ui/Icon';

interface Props {
  value: number | null;
  onChange?: (stars: number) => void;
  size?: 'sm' | 'md';
  showCount?: boolean;
  count?: number;
}

export function StarRating({ value, onChange, size = 'md', showCount, count }: Props) {
  const [hovered, setHovered] = useState<number | null>(null);
  const px = size === 'sm' ? 12 : 16;
  const display = hovered ?? value ?? 0;

  return (
    <div className="flex items-center gap-1">
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map(n => (
          <button
            key={n}
            type="button"
            disabled={!onChange}
            onClick={() => onChange?.(n)}
            onMouseEnter={() => onChange && setHovered(n)}
            onMouseLeave={() => onChange && setHovered(null)}
            className={onChange ? 'cursor-pointer transition-transform hover:scale-110' : 'cursor-default'}
            aria-label={`${n} star`}
          >
            <Star
              size={px}
              strokeWidth={1.5}
              className={n <= display ? 'text-amber-400 fill-amber-400' : 'text-slate-200 dark:text-slate-700'}
            />
          </button>
        ))}
      </div>
      {showCount && count !== undefined && (
        <span className="font-mono text-[10px] text-slate-400 ml-0.5">({count})</span>
      )}
    </div>
  );
}
